import { ISize } from '@shared/bff';

export const LOGO_URLS_SIZES: ISize[] = [
  { width: 50, height: 50 },
  { width: 65, height: 65 },
  { width: 100, height: 100 },
  { width: 130, height: 130 },
  { width: 360, height: 280 },
];
